export const reportsConstants = {
  LOADING_REPORTS__START: 'LOADING_REPORTS__START',
  LOADING_REPORTS__SUCCESS: 'LOADING_REPORTS__SUCCESS',
  LOADING_REPOSTS__ERROR: 'LOADING_REPOSTS__ERROR',
  CHANGE_METRIC: 'CHANGE_METRIC',
  CHANGE_DIMENSION: 'CHANGE_DIMENSION',
  RESET_STATE: 'RESET_STATE',
};
